var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from 'react';
import { useUniqueId } from '../../hooks/useUniqueId';
import { createContext } from '../../utils/createContext';
import { ModalAnimationState } from './type';
var _a = createContext(), context = _a[0], useContext = _a[1];
export var ModalContext = context;
export var ModalProvider = function (props) {
    var children = props.children, otherProps = __rest(props, ["children"]);
    var _a = useState(ModalAnimationState.IDLE), animationState = _a[0], setAnimationState = _a[1];
    var uniqueId = useUniqueId();
    return (<ModalContext state={__assign({ uniqueId: uniqueId, animationState: animationState, changeAnimationState: changeAnimationState, nextAnimationState: nextAnimationState }, otherProps)}>
      {children}
    </ModalContext>);
    function changeAnimationState(state_) {
        setAnimationState(function () { return state_; });
    }
    function nextAnimationState() {
        setAnimationState(function (state_) {
            var next = state_ + 1;
            if (next === ModalAnimationState.DEAD)
                return ModalAnimationState.IDLE;
            return next;
        });
    }
};
// export const useModalContext = useContext
export function useModalContext(props) {
    var state = useContext().state;
    return __assign(__assign({}, props), state);
}
//# sourceMappingURL=context.jsx.map